import PropTypes from "prop-types";
import * as React from "react";
import { Button, Dialog } from "../../themeV2";
import AuthFlow from "./AuthFlow";

const TITLE = Object.freeze({ login: "Log in", create: "Create an account" });
const SWITCH = Object.freeze({
  login: {
    prompt: "Don't have an account?",
    action: "Create one",
    to: "create",
  },
  create: { prompt: "Already have an account?", action: "Log in", to: "login" },
});

export default function AuthDialog({ initialMode = "login", onClose }) {
  const [open, setOpen] = React.useState(true);
  const [mode, setMode] = React.useState(initialMode);
  const signedInAs = React.useRef(undefined);
  const { prompt, action, to } = SWITCH[mode];

  const handleSuccess = (user) => {
    signedInAs.current = user;
    setOpen(false);
  };

  return (
    <Dialog.Root
      open={open}
      onOpenChange={setOpen}
      /* Callers unmount this dialog in onClose, so it waits for the exit animation. */
      onOpenChangeComplete={(isOpen) => {
        if (!isOpen) onClose(signedInAs.current);
      }}
    >
      <Dialog.Popup size="sm">
        <Dialog.Title>{TITLE[mode]}</Dialog.Title>
        <Dialog.Body>
          <AuthFlow
            key={mode}
            mode={mode}
            onSuccess={handleSuccess}
            modeSwitch={
              <p>
                {prompt}{" "}
                <Button variant="text" size="sm" onClick={() => setMode(to)}>
                  {action}
                </Button>
              </p>
            }
          />
        </Dialog.Body>
      </Dialog.Popup>
    </Dialog.Root>
  );
}

AuthDialog.propTypes = {
  initialMode: PropTypes.oneOf(["login", "create"]),
  onClose: PropTypes.func.isRequired,
};
